/* eslint-disable react-hooks/exhaustive-deps */
//#region Libraries
import { useState, useEffect } from "react";
//#endregion
//#region Styles
import { Column, Row } from "components/styles";
import{
    Container,
    Title
} from "./styles";
//#endregion
//#region Components
import TooltipButton from "components/TooltipButton/TooltipButton";
//#endregion

const ROW_PROPS = {
    "primary": {},
    "secondary": {
        content: {
            minWidth: "unset",
            width: "75%"
        },
        subcontent: {
            justifyContent: "flex-start"
        } 
    }
};
const CardLinkItemV2 = ({
    className,
    title, icon, to,
    tooltip,
    variant = "primary"
}) => {
    const [tooltipProps, setTooltipProps] = useState({ ...tooltip.props.maxSize });
    useEffect(() => {
        const handlerResizeWindow = () => {
            setTooltipProps(
                window.innerWidth > 1220 
                ? { ...tooltip.props.maxSize } 
                : { ...tooltip.props.minSize });
        }
        handlerResizeWindow();
        window.addEventListener("resize", handlerResizeWindow);
        return () => window.removeEventListener("resize", handlerResizeWindow);
    }, []);
    const getClassName = () => {
        return [variant, className].join(" ");
    }
    const rowPropsValue = ROW_PROPS[variant];
    return (
        <Container className={getClassName()} to={to}>
            <Column {...rowPropsValue.content}>
                <Row align="center">{icon}</Row>
                <Row {...rowPropsValue.subcontent}>
                    <Title className={variant}>{title}</Title>
                    <TooltipButton 
                        tooltipProps={tooltipProps}
                        message={tooltip.message}/>
                </Row>
            </Column>
        </Container>
    );
}

export default CardLinkItemV2;